import { FC } from 'react';
import { Box } from '@mui/material';
import ButtonGroup from '../../../../common/components/ButtonGroup';

const SendSlackMessgeFooter: FC<
  React.PropsWithChildren<SendSlackMessgeFooterProps>
> = ({ onClose, onSubmit, isActionDisabled, loadingSubmit }) => {
  return (
    <Box display='flex' alignItems='end'>
      <ButtonGroup
        onCancel={onClose}
        onClick={onSubmit}
        buttonCancelLabel='Cancel'
        buttonCancelTooltip='Cancel'
        buttonActionLabel='Send'
        buttonActionTooltip='Send'
        isActionDisabled={isActionDisabled}
        isLoading={loadingSubmit}
      />
    </Box>
  );
};

export interface SendSlackMessgeFooterProps {
  onClose: () => void;
  onSubmit: () => void;
  loadingSubmit: boolean;
  isActionDisabled: boolean;
}

export default SendSlackMessgeFooter;
